import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RefreshDataService, RefreshStatus } from './refresh-data.service';
import { faSync, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

declare var bootstrap: any;

@Component({
  selector: 'app-refresh-data-modal',
  templateUrl: './refresh-data-modal.component.html',
  styleUrls: ['./refresh-data-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RefreshDataModalComponent implements OnInit, OnDestroy {
  faSync = faSync;
  faCheckCircle = faCheckCircle;
  faExclamationTriangle = faExclamationTriangle;

  refreshStatus: RefreshStatus = {
    isLoading: false,
    message: '',
    isError: false,
  };

  private subscription?: Subscription;
  private modal: any;

  constructor(private refreshDataService: RefreshDataService) {}

  ngOnInit() {
    // Initialize Bootstrap modal after view init
    setTimeout(() => {
      const modalElement = document.getElementById('refreshDataModal');
      if (modalElement && typeof bootstrap !== 'undefined') {
        this.modal = new bootstrap.Modal(modalElement);
      }
    }, 100);

    // Subscribe to refresh status updates
    this.subscription = this.refreshDataService.refreshStatus$.subscribe((status: RefreshStatus) => {
      this.refreshStatus = status;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  show() {
    if (this.modal) {
      this.modal.show();
    }
  }

  hide() {
    if (this.modal) {
      this.modal.hide();
    }
  }
}
